import { $color } from "@/utils/cssVarUtils"
import {
  mode,
  SystemStyleFunction,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"
import { rgba } from "polished"


const baseStyle: SystemStyleObject = {
  borderRadius: '1em',
  px: '0.666667em',
  py: '0.333333em',
  fontSize: 'xs',
  textTransform: 'none',
  fontWeight: 'normal',
  lineHeight: 1,
  display: 'inline-flex',
  alignItems: 'center',
  minH: '2xl'
}


const variantOutline: SystemStyleFunction = (props) => {
  const { colorScheme: c } = props
  const color = $color(`scene-${c}-normal`)

  return {
    color,
    boxShadow: `${color} 0px 0px 0px 1px inset`,
  }
}

const variantSolid: SystemStyleFunction = (props) => {
  const { colorScheme: c } = props
  let color = mode($color('dark-text-normal'), $color('light-text-normal'))(props)
  if (['danger', 'primary', 'purple'].includes(c)) {
    color = $color('dark-text-normal')
  }

  const bg = $color(`scene-${c}-normal`)

  return {
    bg,
    color: color,
  }
}

const variantSubtle: SystemStyleFunction = (props) => {
  const { colorScheme: c, theme } = props
  const bgColor = rgba(theme.colors.scene[c]?.normal, 0.1)
  const color = $color(`scene-${c}-normal`)

  return {
    bg: bgColor,
    color,
  }
}


const variants = {
  "outline": variantOutline,
  "solid": variantSolid,
  "subtle": variantSubtle,
}


const defaultProps = {
  variant: "subtle",
  colorScheme: 'primary',
}

export const Badge = {
  baseStyle,
  defaultProps,
  variants,
}